import type { Channel } from "../../types/analytics";
import { CHANNEL_COLOR, CHANNEL_LABEL, CHANNEL_ORDER, PRESET_LABEL, diffDays, type Preset } from "../../lib/analyticsCalc";

const PRESETS: Exclude<Preset, "custom">[] = ["7d", "30d", "tm", "lm", "90d", "all"];
const GRANULARITIES: { key: "day" | "week" | "month"; label: string }[] = [
  { key: "day", label: "日次" },
  { key: "week", label: "週次" },
  { key: "month", label: "月次" },
];

interface FilterBarProps {
  preset: Preset;
  from: string;
  to: string;
  minDate: string;
  maxDate: string;
  granularity: "day" | "week" | "month";
  channels: Record<Channel, boolean>;
  productName: string | null;
  onPreset: (p: Preset) => void;
  onCustomFrom: (v: string) => void;
  onCustomTo: (v: string) => void;
  onGranularity: (g: "day" | "week" | "month") => void;
  onToggleChannel: (ch: Channel) => void;
  onClearProduct: () => void;
}

export function FilterBar({
  preset,
  from,
  to,
  minDate,
  maxDate,
  granularity,
  channels,
  productName,
  onPreset,
  onCustomFrom,
  onCustomTo,
  onGranularity,
  onToggleChannel,
  onClearProduct,
}: FilterBarProps) {
  const rangeDays = diffDays(from, to) + 1;

  return (
    <div className="an-filterbar">
      <div className="an-filterbar-inner">
        <div className="an-seg" role="group" aria-label="期間プリセット">
          {PRESETS.map((p) => (
            <button key={p} className={`an-seg-btn ${preset === p ? "active" : ""}`} onClick={() => onPreset(p)}>
              {PRESET_LABEL[p]}
            </button>
          ))}
        </div>

        <div className="an-daterange">
          <input type="date" value={from} min={minDate} max={maxDate} onChange={(e) => e.target.value && onCustomFrom(e.target.value)} />
          <span style={{ color: "var(--an-text-sub)" }}>〜</span>
          <input type="date" value={to} min={minDate} max={maxDate} onChange={(e) => e.target.value && onCustomTo(e.target.value)} />
          <span className="an-daterange-days">{rangeDays}日間</span>
        </div>

        <div className="an-seg" role="group" aria-label="集計粒度">
          {GRANULARITIES.map((g) => (
            <button key={g.key} className={`an-seg-btn small ${granularity === g.key ? "active" : ""}`} onClick={() => onGranularity(g.key)}>
              {g.label}
            </button>
          ))}
        </div>

        <div className="an-chips">
          {CHANNEL_ORDER.map((ch) => (
            <button key={ch} className={`an-chip ${channels[ch] ? "on" : ""}`} onClick={() => onToggleChannel(ch)}>
              <span className="an-chip-dot" style={{ background: CHANNEL_COLOR[ch] }} />
              {CHANNEL_LABEL[ch]}
            </button>
          ))}
        </div>

        {productName && (
          <button className="an-product-pill" onClick={onClearProduct}>
            <span className="muted">商品</span>
            {productName}
            <span className="x">×</span>
          </button>
        )}
      </div>
    </div>
  );
}
